import { bound } from "@frui.ts/helpers";
import { ConductorSingleChild } from "@frui.ts/screens/dist";
import { Modules } from "config";
import type LocalizationService from "services/localizationService";
import type BulkExemptionsViewModel from "./bulkExemptionsViewModel";
import type DistributorStornoViewModel from "./distributorStornoViewModel";
import type ChangeVehicleViewModel from "./changeVehicleViewModel";

export default class ActionsViewModel extends ConductorSingleChild<
  BulkExemptionsViewModel | DistributorStornoViewModel | ChangeVehicleViewModel
> {
  protected childNavigationPathClosed = true;

  constructor(
    private bulkExemptionViewModelFactory: () => BulkExemptionsViewModel,
    private distributorStornoViewModelFactory: () => DistributorStornoViewModel,
    private changeVehicleViewModelFactory: () => ChangeVehicleViewModel,
    private localizationService: LocalizationService
  ) {
    super();
  }

  protected findNavigationChild(navigationName: string | undefined) {
    return undefined;
  }

  @bound
  onDistributorStornoClick() {
    this.tryActivateChild(this.distributorStornoViewModelFactory());
  }

  @bound
  onBulkExemptionsClick() {
    this.tryActivateChild(this.bulkExemptionViewModelFactory());
  }

  @bound
  onChangeVehicleClick() {
    this.tryActivateChild(this.changeVehicleViewModelFactory());
  }

  translate(code: string) {
    return this.localizationService.translateModule(Modules.callCenter, code);
  }
}
